/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_BillingInputs */

const da_privacy_data_billing = /** @type {(inputs: Privacy_Data_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Betaling:** faktureringsnavn, e-mailadresse, adresse, evt. CVR- eller momsnummer og EAN samt købshistorik. Kortoplysninger håndteres alene af Stripe. Vi ser dem aldrig.`)
};

/** @type {(inputs: Privacy_Data_BillingInputs) => LocalizedString} */
const en_privacy_data_billing = da_privacy_data_billing;

/**

* @param {Privacy_Data_BillingInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_billing = /** @type {((inputs?: Privacy_Data_BillingInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_BillingInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_billing(inputs)
	return /** @type {LocalizedString} */ ("**Betaling:** faktureringsnavn, e-mailadresse, adresse, evt. CVR- eller momsnummer og EAN samt købshistorik. Kortoplysninger håndteres alene af Stripe. Vi ser dem aldrig.")
});